import eq from 'lodash/eq';
import fetch from './fetch';
import config from '../config';
import logger from './logger';
import { cookieStringToMap } from './cookie';

const getArrivalKey = () => {
  const cookie = cookieStringToMap(document.cookie);
  const { environment } = config;
  return ((environment === 'production') ? cookie.jc_arrival : cookie.jc_arrival_staging);
};

export const Reporter = (defaultMetadata = {}) => {
  const metadata = { ...defaultMetadata };

  return {
    setMetadata(key, value) {
      metadata[key] = value;
    },
    async report(name, data, options = {}) {
      // page view events require auth data, which is not available in the /v2/report endpoint
      const path = eq(name, 'PageViewEvent') ? '/v1/page-view' : `/v2/report?x-analytics-key=${config.analyticsKey}`;
      const body = {
        event_id: name,
        data: {
          eventVersion: null,
          ...data,
        },
      };

      // Add metadata for unversioned events only.
      if (!body.data.eventVersion) {
        body.data = { ...body.data, ...metadata };
      }

      try {
        const response = await fetch(`${config.apiUrl}${path}`, {
          method: 'POST',
          fullResponse: true,
          headers: {
            'X-Analytics-Key': config.analyticsKey,
          },
          body,
          ...options,
        });
        return response;
      } catch (err) {
        // TODO - this exclusion is not recommended. Reporting should be fixed to not hit this issue on async calls.
        if (err.message.includes('Cannot set headers after they are sent to the client')) {
          logger.logDebug(`Error calling Reporting Service for ${name}`, err);
        } else {
          logger.logError(`Error calling Reporting Service for ${name}`, err);
        }
      }

      return null;
    },
    async reportStreamableViewEvent(data, options = {}) {
      const path = '/v1/reporting/views';

      const body = {
        conversation_view_events: [{
          ...data,
        }],
      };

      try {
        const response = await fetch(`${config.apiUrl}${path}?arrivalKey=${getArrivalKey()}`, {
          method: 'POST',
          fullResponse: true,
          headers: {
            'X-Analytics-Key': config.analyticsKey,
          },
          body,
          ...options,
        });
        return response;
      } catch (err) {
        // TODO - this exclusion is not recommended. Reporting should be fixed to not hit this issue on async calls.
        if (err.message.includes('Cannot set headers after they are sent to the client')) {
          logger.logDebug(`Error calling Reporting Service for ${data}`, err);
        } else {
          logger.logError(`Error calling Reporting Service for ${data}`, err);
        }
      }

      return null;
    },
  };
};

export default Reporter();
